module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8BAMAAABiEQL9AAAAKlBMVEXOESb80RYHiTD///8MizSJx530+vbk8umq17gynlSw2b2v2b1gs3pfs3nc58CsAAAAhElEQVRIx2MYBSMeCBIJRrUMWy1KeAERWlScSNaic4hkLdqLSNQSqaRepDSVJC2TW5xNPCxJ0qJhFmya3ESSFpVkY2MzJ9K0BBsbm5KiReVWsTEQmO91Il7LbYiWtU60cxjC+7QMZERU0irBIIDWJjISP+2zGCYYWoXSqBZaaBkFIx0AAP6RocVEag0gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag/100px-Flag_of_Barranquilla.svg.png
// module id = gphm
// module chunks = 1